export const enum AMP_VERTICALS {
  LOUNGES = 'LOUNGES',
  PARKING = 'PARKING',
  CAR_RENTAL = 'CAR_RENTAL',
  EURAIL = 'EURAIL',
}

export const enum LegalContentType {
  TRACKING = 'tracking',
  PRIVACY = 'privacy',
  TERMS = 'terms',
  IMPRINT = 'imprint',
}

export const enum TransferDirection {
  TO_AIRPORT = 'TO_AIRPORT',
  FROM_AIRPORT = 'FROM_AIRPORT',
}

export const enum YILU_FEATURE {
  SHOW_TRACKING_CONSENT = 'SHOW_TRACKING_CONSENT',
  SHOW_NAVIGATION_BAR = 'SHOW_NAVIGATION_BAR',
  DISABLE_CREDIT_CARD_PAYMENTS = 'DISABLE_CREDIT_CARD_PAYMENTS',
}

export const SupportedFeatureFlags = [
  YILU_FEATURE.SHOW_TRACKING_CONSENT,
  YILU_FEATURE.SHOW_NAVIGATION_BAR,
  YILU_FEATURE.DISABLE_CREDIT_CARD_PAYMENTS,
];

// To ensure unique override keys we define a list of available keys here
export const enum YILU_OVERRIDE_KEY {
  YILU_HEADER_LOGO = 'yiluHeaderLogo',
}
